module.exports = require("babel-runtime/core-js/object/values");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/values"
// module id = 30
// module chunks = 0 1 2 3 4 5 6 7 10 11